// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610220725/js/" + chunkId + "." + {"44":"be858cf1","225":"d56a4071","481":"4c356563","486":"9a7c3028","770":"53b75a48"}[chunkId] + ".0.6065866115775211.chunk.js";
};